<template>
  <UiModal
    id="confirmContainer"
    :show="showExit"
    :title="confirmOptions?.title"
    :iconType="confirmOptions?.iconType"
    @close="closeModal()"
  >
    <div class="inner-content">
      <span>{{ confirmOptions?.tip }}</span>
    </div>
    <div class="bottom-box">
      <UiButton class="btn" :colorType="confirmOptions?.cancel?.colorType" @click="handleCancel">
        <div class="label-box">
          <span class="label-shadow">{{ confirmOptions?.cancel?.label }}</span>
          <span class="label-text">{{ confirmOptions?.cancel?.label }}</span>
        </div>
      </UiButton>
      <UiButton class="btn" :colorType="confirmOptions?.apply?.colorType" @click="handleApply">
        <div class="label-box">
          <span class="label-shadow">{{ confirmOptions?.apply?.label }}</span>
          <span class="label-text">{{ confirmOptions?.apply?.label }}</span>
        </div>
      </UiButton>
    </div>
  </UiModal>
</template>

<script setup>
import { ref, watch } from 'vue'
import UiModal from "@/components/ui-modal.vue";
import UiButton from '@/components/ui-button';

const DEFAULT_OPTIONS = {
  title: '友情提示',
  tip: '二次确认',
  iconType: 'tip',
  cancel: { label: '返回', colorType: 'gold' },
  apply:  { label: '退出', colorType: 'red'  }
}

const props = defineProps({
  options: {
    type: Object,
    default: () => ({})
  }
})

const emit = defineEmits(['cancel', 'apply'])

const showExit = ref(false)
const confirmOptions = ref({})

watch(
  () => props.options,
  (newVal) => {
    confirmOptions.value = { ...DEFAULT_OPTIONS, ...newVal }
  },
  { immediate: true, deep: true }
)

function showModal() {
  showExit.value = true;
}
function closeModal() {
  showExit.value = false;
}
function handleCancel() {
  closeModal()
  emit('cancel')
}
function handleApply() {
  closeModal()
  emit('apply')
}

defineExpose({ showModal, closeModal })
</script>

<style lang="scss">
#confirmContainer {
  .modal__container {
    width: 646px;
    height: 380px;
    margin-left: -0.5 * 646px;
    background-image: $bg_popup_mini;
    .modal__inner {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 24px 0 51.6px;
      margin: 0;
      .modal__header {
        margin-left: 44px;
        flex-shrink: 0; // 标题不参与收缩, 保持完整高度
      }
      .modal__body {
        flex: 1; // 占满 modal__inner 剩余空间, 覆盖 ui-modal 默认 height: 542px (大弹窗尺寸)
        min-height: 0; // 允许 flex 收缩, 避免内容撑破 380px 小弹窗溢出到屏幕下方
        height: auto;
        width: 100%;
        background: none;
      }
      .title {
        width: 195px;
        font-weight: 500;
        .bg {
          display: none;
        }
      }
    }
  }

  .inner-content {
    flex: 1;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    color: #333333;
    font-weight: 500;
  }
  .bottom-box {
    height: 71px;
    display: flex;
    justify-content: center;
    .btn {
      width: 266px;
      height: 100%;
      font-size: 30px;
      font-weight: bold;
      margin: 0 8px;
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      &:active {
        opacity: 0.9;
      }
    }
  }
}
</style>